"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CountChecked = _interopRequireDefault(require("./CountChecked"));

var _NumberUtil = _interopRequireDefault(require("../NumberUtil"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var startDate = 'July 22, 2019 00:00:00';
var checked = (0, _CountChecked["default"])(startDate, new Date().toString());

var getCountChecked = function getCountChecked() {
  return (0, _NumberUtil["default"])(checked);
};

var _default = getCountChecked;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9Db3VudENoZWNrZWQvR2V0Q291bnRDaGVja2VkLnRzIl0sIm5hbWVzIjpbInN0YXJ0RGF0ZSIsImNoZWNrZWQiLCJEYXRlIiwidG9TdHJpbmciLCJnZXRDb3VudENoZWNrZWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7OztBQUVBLElBQU1BLFNBQWlCLEdBQUcsd0JBQTFCO0FBQ0EsSUFBTUMsT0FBZSxHQUFHLDhCQUFhRCxTQUFiLEVBQXdCLElBQUlFLElBQUosR0FBV0MsUUFBWCxFQUF4QixDQUF4Qjs7QUFDQSxJQUFNQyxlQUFlLEdBQUcsU0FBbEJBLGVBQWtCO0FBQUEsU0FBYyw0QkFBbUJILE9BQW5CLENBQWQ7QUFBQSxDQUF4Qjs7ZUFFZUcsZSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBjb3VudENoZWNrZWQgZnJvbSAnLi9Db3VudENoZWNrZWQnO1xuaW1wb3J0IEdlcm1hbk51bWJlckZvcm1hdCBmcm9tICcuLi9OdW1iZXJVdGlsJztcblxuY29uc3Qgc3RhcnREYXRlOiBzdHJpbmcgPSAnSnVseSAyMiwgMjAxOSAwMDowMDowMCc7XG5jb25zdCBjaGVja2VkOiBudW1iZXIgPSBjb3VudENoZWNrZWQoc3RhcnREYXRlLCBuZXcgRGF0ZSgpLnRvU3RyaW5nKCkpO1xuY29uc3QgZ2V0Q291bnRDaGVja2VkID0gKCk6IHN0cmluZyA9PiBHZXJtYW5OdW1iZXJGb3JtYXQoY2hlY2tlZCk7XG5cbmV4cG9ydCBkZWZhdWx0IGdldENvdW50Q2hlY2tlZDtcbiJdfQ==